import { default as Slider } from "react-multi-carousel";

import AuctionCard from "../auctionCard";

import CATEGORIES from "../../assets/Categories";
import FLAGS from "../../assets/Flags";

import "./carouselStyles.css";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  largeDesktop: {
    breakpoint: { max: 3000, min: 1200 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1200, min: 768 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 768, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Carousel = ({ NFTs, background }) => {
  return (
    <Slider
      containerClass={`${
        background ? "carousel-container" : "carousel-container-no-background"
      }`}
      sliderClass="carousel-slider"
      responsive={responsive}
      // removeArrowOnDeviceType={["tablet", "mobile"]}
      shouldResetAutoplay={false}
    >
      {NFTs.map((NFT, index) => (
        <AuctionCard
          key={index}
          id={NFT._id}
          tokenId={NFT.tokenId}
          video={NFT.assetUrl}
          name={NFT.name}
          category={CATEGORIES(NFT.category.toLowerCase())}
          country={FLAGS(NFT.countryCode.toLowerCase())}
          countryCode={NFT.countryCode}
          point={NFT.point}
          tier={NFT.tier}
          state={NFT.state}
          owner={NFT.owner}
          startDate={NFT.startDate}
          expirationDate={NFT.expirationDate}
          bestBid={NFT.bestBid}
          bids={NFT.bids}
          initialValue={NFT.initialValue}
          currentValue={NFT.currentValue}
          userHasBids={NFT.userHasBids}
          auctioneerState={NFT.auctioneerState}
        />
      ))}
    </Slider>
  );
};

export default Carousel;
